export const pages: string[] = ['Home', 'Orders', 'Charges',  'Violations', 'Calculator', 'Hunting Zones'];
